import { ArtifactName } from '@/api/generated-types';

export const ARTIFACT_FILENAMES: Record<ArtifactName, string> = {
  [ArtifactName.Extracted]: 'extracted.json',
  [ArtifactName.Curated]: 'curated.json',
  [ArtifactName.OriginalPdf]: 'original.pdf',
  [ArtifactName.LayoutExtracted]: 'layout_extracted.json',
  [ArtifactName.MergedResult]: 'merged_result.json',
  [ArtifactName.FailedExtraction]: 'failed_extraction.json',
  [ArtifactName.SubstanceValidation]: 'substance_validation.json',
  [ArtifactName.FormData]: 'form_data.json',
  [ArtifactName.SavedValidation]: 'saved_validation.json',
  [ArtifactName.DcmRawText]: 'dcm_raw_text.txt',
  [ArtifactName.RawExtraction]: 'raw_extraction.json',
};

export const ARTIFACT_DISPLAY_NAMES: Record<ArtifactName, string> = {
  [ArtifactName.Extracted]: 'Extracted',
  [ArtifactName.Curated]: 'Curated',
  [ArtifactName.OriginalPdf]: 'Original PDF',
  [ArtifactName.LayoutExtracted]: 'Layout Extracted',
  [ArtifactName.MergedResult]: 'Merged Result',
  [ArtifactName.FailedExtraction]: 'Failed Extraction',
  [ArtifactName.SubstanceValidation]: 'Substance Verification',
  [ArtifactName.FormData]: 'Form Data',
  [ArtifactName.SavedValidation]: 'Saved Validation',
  [ArtifactName.DcmRawText]: 'DCM Raw Text',
  [ArtifactName.RawExtraction]: 'Raw Extraction',
};

/**
 * What the debug panel shows and the debug-state download ships.
 *
 * These are also what `pnpm seed --from` replays, so a transaction exported from a deployed
 * environment can be rebuilt locally. An artifact left off this list can't be reproduced: the
 * seed has no way to learn state it was never handed.
 */
export const DEBUG_ARTIFACTS = [
  ArtifactName.Extracted,
  ArtifactName.LayoutExtracted,
  ArtifactName.MergedResult,
  ArtifactName.Curated,
  ArtifactName.SubstanceValidation,
  ArtifactName.SavedValidation,
] as const;

export type DebugArtifactName = (typeof DEBUG_ARTIFACTS)[number];

export const FILENAME_DISPLAY_NAMES: Record<string, string> = Object.fromEntries(
  Object.entries(ARTIFACT_FILENAMES).map(([key, filename]) => [
    filename,
    ARTIFACT_DISPLAY_NAMES[Number(key) as ArtifactName],
  ])
);
